export const projectsTableData = [
  {
    img: "https://picsum.photos/200/200",
    name: "Material XD Version",
    members: [
      { img: "https://robohash.org/unique_username.png", name: "Romina Hadid" },
      { img: "https://robohash.org/unique_username.png", name: "Ryan Tompson" },
      { img: "https://robohash.org/unique_username.png", name: "Jessica Doe" },
      { img: "https://robohash.org/unique_username.png", name: "Alexander Smith" },
    ],
    budget: "$14,000",
    completion: 60,
  },
  {
    img: "https://picsum.photos/200/200",
    name: "Add Progress Track",
    members: [
      { img: "https://robohash.org/unique_username.png", name: "Ryan Tompson" },
      { img: "https://robohash.org/unique_username.png", name: "Alexander Smith" },
    ],
    budget: "$3,000",
    completion: 10,
  },
  {
    img: "https://picsum.photos/200/200",
    name: "Fix Platform Errors",
    members: [
      { img: "https://robohash.org/unique_username.png", name: "Jessica Doe" },
      { img: "https://robohash.org/unique_username.png", name: "Romina Hadid" },
    ],
    budget: "Not set",
    completion: 100,
  },
  {
    img: "https://picsum.photos/200/200",
    name: "Launch our Mobile App",
    members: [
      { img: "https://robohash.org/unique_username.png", name: "Alexander Smith" },
      { img: "https://robohash.org/unique_username.png", name: "Jessica Doe" },
      { img: "https://robohash.org/unique_username.png", name: "Ryan Tompson" },
      { img: "https://robohash.org/unique_username.png", name: "Romina Hadid" },
    ],
    budget: "$20,500",
    completion: 100,
  },
  {
    img: "https://picsum.photos/200/200",
    name: "Add the New Pricing Page",
    members: [{ img: "https://robohash.org/unique_username.png", name: "Alexander Smith" }],
    budget: "$500",
    completion: 25,
  },
  {
    img: "https://picsum.photos/200/200",
    name: "Redesign New Online Shop",
    members: [
      { img: "https://robohash.org/unique_username.png", name: "Romina Hadid" },
      { img: "https://robohash.org/unique_username.png", name: "Alexander Smith" },
    ],
    budget: "$2,000",
    completion: 40,
  },
];

export default projectsTableData;
